module.exports = __webpack_public_path__ + "img/start-5.c508a557.png";